import { EventEmitter, Injectable } from '@angular/core';
import { LoadingData } from '@models/loading-data.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    public loadingData: EventEmitter<LoadingData> = new EventEmitter<LoadingData>();
    public loadingData$: Observable<LoadingData> = this.loadingData.asObservable();

    private loadingInstances: string[] = [];

    /**
     * Shows a loading indicator.
     * @param id - Optional unique identifier for the loader instance. If provided, the loader will be tracked and can be hidden by id.
     * @param message - Optional message to display below the spinner. Default: 'Chargement...'
     * @param duration - Optional duration in milliseconds. If > 0, the loader will auto-hide after this duration. Default: 0 (no auto-hide)
     * @param fullHeight - If true, loader takes 100% height (ignoring safe area bottom). Use for full-page blocking operations. Default: false
     */
    public show(id?: string, message = 'Chargement...', duration = 0, fullHeight = false): void {
        if (id && this.loadingInstances.indexOf(id) === -1) {
            this.loadingInstances.push(id);
        }
        this.loadingData.emit({ id, duration, message, fullHeight });
    }

    /**
     * Cache le loader.
     * Si aucun id n'est passé, ou M(odale) ou P(age), force le hide du loader.
     */
    public hide(id?: string): void {
        if (id && this.loadingInstances.indexOf(id) !== -1) {
            this.loadingInstances.splice(this.loadingInstances.indexOf(id), 1);
        }
        if (!id || !this.loadingInstances || this.loadingInstances.length === 0) {
            this.loadingData.emit();
            this.loadingInstances.length = 0;
        }
    }
}
